"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
export default function DustResistantSeals() {
  return <section data-section-id="257713" id="nadzor-u-stvarnom-vremenu" className="bg-background text-foreground py-12 md:py-16 lg:py-20">
      <div className="page-container">
        <div className="mx-auto max-w-4xl space-y-8">
          {}
          <div className="space-y-4">
            <h1 className="font-default text-3xl md:text-4xl font-bold" style={{
            color: "var(--primary)"
          }}>
              Pratite i upravljajte svojim <span className="text-primary">operacijama u stvarnom vremenu</span>
            </h1>
          </div>

          {}
          <div className="space-y-6 text-lg" style={{
          color: "var(--foreground)"
        }}>
            <p className="font-default leading-relaxed text-muted-foreground">Učinkovito upravljajte i pratite sve aktivnosti svojih mobilnih zaposlenika u stvarnom vremenu. Osigurajte potpunu transparentnost i odgovornost svoje radne snage te poboljšajte kvalitetu usluga koje vaša tvrtka pruža.</p>

            <p className="font-default leading-relaxed text-muted-foreground">
              Naša platforma omogućuje menadžerima uvid u kretanje timova putem GPS mapa, dok terenski radnici koriste digitalne kontrolne liste za precizno izvještavanje. Svaki obilazak i incident bilježe se trenutno, eliminirajući potrebu za papirnatom dokumentacijom.
            </p>
          </div>

          {}
          <div className="space-y-4 border-t border-border pt-8">
            <h2 className="font-default text-2xl md:text-3xl font-bold" style={{
            color: "var(--primary)"
          }}>
              Transparentnost i odgovornost na terenu
            </h2>
          </div>

          {}
          <div className="space-y-6 text-lg" style={{
          color: "var(--foreground)"
        }}>
            <p className="font-default leading-relaxed text-muted-foreground">Mobileo softver je dizajniran da uštedi vrijeme upravljanja, poboljša produktivnost i učinak mobilne radne snage. Pomaže vašim zaposlenicima da obavljaju svoje svakodnevne zadatke brže, bolje i učinkovitije unutar jedne digitalne platforme.</p>

            <p className="font-default leading-relaxed text-muted-foreground">
              Uz automatske obavijesti o propuštenim točkama ili incidentima, menadžeri mogu reagirati u sekundi. Klijenti dobivaju pristup portalu gdje vide dokaze o pruženoj usluzi, što gradi povjerenje i dugoročnu suradnju.
            </p>
          </div>

          {}
          <div className="space-y-4 border-t border-border pt-8">
            <h2 className="font-default text-2xl md:text-3xl font-bold" style={{
            color: "var(--primary)"
          }}>
              Digitalna transformacija vašeg poslovanja
            </h2>
          </div>

          {}
          <div className="space-y-6 text-lg" style={{
          color: "var(--foreground)"
        }}>
            <p className="font-default leading-relaxed text-muted-foreground">
              Prebacivanjem na Mobileo, smanjujete operativne troškove i povećavate konkurentnost na tržištu. Naš sustav se prilagođava vašim specifičnim potrebama, bilo da upravljate malim timom ili velikom agencijom s više stotina zaštitara.
            </p>

            <p className="font-default leading-relaxed text-muted-foreground">Nudimo besplatnu prezentaciju sustava za sve tvrtke u Hrvatskoj. Kontaktirajte nas i saznajte kako Mobileo može transformirati vašu tvrtku. Nazovite +385 91 650 9999 za besplatnu procjenu.</p>
          </div>

          {}
          <div className="mt-12 rounded-xl p-8 md:p-10 shadow-lg" style={{
          backgroundColor: "var(--primary)"
        }}>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="flex h-12 w-12 items-center justify-center rounded-lg" style={{
                  backgroundColor: "rgba(255, 255, 255, 0.2)"
                }}>
                    <Phone className="h-6 w-6 text-white" />
                  </div>
                </div>
                <div>
                  <h3 className="font-default text-xl font-bold mb-2 text-white">
                    Spremni za modernizaciju?
                  </h3>
                  <p className="font-default text-sm leading-relaxed text-white/90">
                    Želite vidjeti kako Mobileo radi u praksi? Naš tim stručnjaka spreman je pokazati vam sve prednosti sustava. Zakažite demo prezentaciju već danas.
                  </p>
                </div>
              </div>

              <Link to="tel:+385916509999" className="flex-shrink-0 bg-secondary text-secondary-foreground hover:bg-secondary/90 font-semibold px-6 py-3 h-auto rounded-lg shadow-md">Nazovite +385 91 650 9999</Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}